import {
  Menu,
  ViewLogin,
  PersonSelMen,
  PersonCardPointment,
  ShowAppointment,
  Agreement,
  PersonAppointment,
  TeamAppointment,
  ReservationRecord,
  LogoTeam,
  RegisteredTeam,
  ShowTeamAppointment,
  ShowAppointmentFaild,
  AgreementTeam
} from '../pages'
export const mainRoutes = [
  {
    pathname: '/Main/Menu',
    component: Menu,
    title: '参观预约'
  },
  {
    pathname: '/Main/ViewLogin',
    component: ViewLogin,
    title: '查看登录码'
  },
  {
    pathname: '/Main/PersonSelMen',
    component: PersonSelMen,
    title: '入馆方式选择'
  },
  {
    pathname: '/Main/ShowAppointment',
    component: ShowAppointment,
    title: '预约'
  },
  {
    pathname: '/Main/PersonCardPointment',
    component: PersonCardPointment,
    title: '预约刷卡'
  },
  {
    pathname: '/Main/Agreement',
    component: Agreement,
    title: '协议'
  },
  {
    pathname: '/Main/AgreementTeam',
    component: AgreementTeam,
    title: '团队协议'
  },
  {
    pathname: '/Main/PersonAppointment',
    component: PersonAppointment,
    title: '个人预约',
  },
  {
    pathname: '/Main/TeamAppointment',
    component: TeamAppointment,
    title: '团队预约'
  },
  {
    pathname: '/Main/ReservationRecord',
    component: ReservationRecord,
    title: '预约记录'
  },
  {
    pathname: '/Main/LogoTeam',
    component: LogoTeam,
    title: '团队登录'
  },
  {
    pathname: '/Main/RegisteredTeam',
    component: RegisteredTeam,
    title: '团队注册'
  },
  {
    pathname: '/Main/ShowTeamAppointment',
    component: ShowTeamAppointment,
    title: '预约注册审核'
  },
  {
    pathname: '/Main/ShowAppointmentFaild',
    component: ShowAppointmentFaild,
    title: '团队预约失败'
  },

]
